import React from 'react'

export default function ReplaceContent() {
    const logo = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_132_77733)">
            <circle cx="12" cy="12" r="11.5" fill="black" stroke="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3438 14.0322H5.66029C5.60655 13.8672 5.55911 13.6993 5.51824 13.5289H18.4859C18.445 13.6993 18.3976 13.8672 18.3438 14.0322ZM16.2018 17.1406H7.80231C7.60853 16.9837 7.42376 16.8161 7.24889 16.6387H16.7552C16.5804 16.8161 16.3956 16.9837 16.2018 17.1406ZM6.07489 15.023C6.18615 15.2379 6.30883 15.446 6.4421 15.6465H17.562C17.6953 15.446 17.818 15.2379 17.9292 15.023H6.07489ZM12.0021 18.6256C11.1091 18.6256 10.2571 18.4505 9.47883 18.1329H14.5253C13.747 18.4505 12.895 18.6256 12.0021 18.6256ZM5.35894 12.5366C5.34522 12.3724 5.33748 12.2065 5.33594 12.0391H18.6682C18.6666 12.2065 18.6589 12.3724 18.6452 12.5366H5.35894ZM5.40035 11.0469C5.42991 10.8362 5.46938 10.6287 5.51825 10.4249H18.4859C18.5347 10.6287 18.5742 10.8362 18.6038 11.0469H5.40035ZM5.65952 9.92389L5.65827 9.92773H18.3458L18.3446 9.92389H5.65952ZM5.84361 9.42676C5.9134 9.2593 5.98985 9.0953 6.07265 8.93509H17.9315C18.0143 9.0953 18.0907 9.2593 18.1605 9.42676H5.84361ZM6.35891 8.43558L6.35739 8.43799H17.6467L17.6452 8.43558H6.35891ZM6.70582 7.93848C6.83882 7.76523 6.98018 7.5987 7.12929 7.43949H16.8748C17.0239 7.5987 17.1653 7.76523 17.2983 7.93848H6.70582ZM7.64758 6.94238H16.3565L16.3537 6.93997H7.65037L7.64758 6.94238ZM12.0021 5.32812C13.3693 5.32812 14.6405 5.73866 15.6983 6.44287H8.3058C9.36364 5.73866 10.6348 5.32812 12.0021 5.32812Z" fill="#5BF0A5" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0572 7.93848C11.3351 7.57645 11.6495 7.24375 11.9949 6.94583H7.63995C7.29454 7.24375 6.98013 7.57645 6.7022 7.93848H11.0572ZM10.7103 8.43558H6.35529C6.15475 8.75279 5.98035 9.08809 5.83512 9.43848H10.1901C10.3353 9.08809 10.5097 8.75279 10.7103 8.43558ZM5.39673 11.0469C5.45031 10.6651 5.53639 10.2937 5.6521 9.93561H10.0071C9.89137 10.2937 9.80529 10.6651 9.75171 11.0469H5.39673ZM5.34593 11.544C5.33671 11.6871 5.33203 11.8315 5.33203 11.9769C5.33203 12.1674 5.34007 12.356 5.35581 12.5425H9.71079C9.69505 12.356 9.68701 12.1674 9.68701 11.9769C9.68701 11.8315 9.69169 11.6871 9.70091 11.544H5.34593ZM5.65667 14.0322C5.55219 13.7114 5.47152 13.3798 5.41673 13.0396H9.77171C9.8265 13.3798 9.90718 13.7114 10.0116 14.0322H5.65667ZM5.84097 14.5294C6.00578 14.9244 6.2077 15.3002 6.44238 15.6523H10.7974C10.5627 15.3002 10.3608 14.9244 10.196 14.5294H5.84097ZM7.79869 17.1406C7.4347 16.8458 7.10249 16.5134 6.80797 16.1495H11.163C11.4575 16.5134 11.7897 16.8458 12.1537 17.1406H7.79869ZM8.50022 17.6378C9.51711 18.2642 10.7155 18.6256 11.9984 18.6256C12.7609 18.6256 13.4935 18.498 14.1759 18.2629C13.7101 18.1024 13.2677 17.8919 12.8552 17.6378H8.50022ZM14.1759 5.69089C13.6313 5.87852 13.1187 6.13457 12.6484 6.44873H8.29339C9.35298 5.74093 10.6274 5.32812 11.9984 5.32812C12.7609 5.32812 13.4935 5.4558 14.1759 5.69089Z" fill="#5BF0A5" />
        </g>
        <defs>
            <clipPath id="clip0_132_77733">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
    return (
        <div className="replace-content">
            <div className="replace-wrapper">
                <div className="replace-left">
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r1.webp'} alt="" />
                        <span>Digital Marketer</span>
                    </div>
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r2.webp'} alt="" />
                        <span>Copywriter</span>
                    </div>
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r3.webp'} alt="" />
                        <span>Motion Designer</span>
                    </div>
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r4.webp'} alt="" />
                        <span>Actor</span>
                    </div>
                </div>
                <div className="replace-svg--1">
                    <svg width="138" height="124" viewBox="0 0 138 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 123H79C85.6274 123 91 117.627 91 111V41" stroke="#D1D7DD" />
                        <path d="M55 1H79C85.6274 1 91 6.37258 91 13V41" stroke="#D1D7DD" />
                        <path d="M30 42H59.1639C64.9628 42 69.6639 46.701 69.6639 52.5V52.5C69.6639 58.299 74.3649 63 80.1639 63H89" stroke="#D1D7DD" />
                        <path d="M58 83L61 83C66.5228 83 71 78.5228 71 73V73C71 67.4772 75.4772 63 81 63H88" stroke="#D1D7DD" />
                        <path d="M138 63L133 60.1132V65.8868L138 63ZM91 63.5H133.5V62.5H91V63.5Z" fill="#CAD4DD" />
                        <circle cx="91" cy="63" r="4.5" fill="white" stroke="#D1D7DD" />
                    </svg>
                </div>
                <div className="replace-right">
                    AI Copilot for
                    video ads
                    {logo}

                </div>
            </div>
            <div className="replace-wrapper">
                <div className="replace-left">
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r5.webp'} alt="" />
                        <span>Digital Marketer</span>
                    </div>
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r6.webp'} alt="" />
                        <span>Copywriter</span>
                    </div>
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r7.webp'} alt="" />
                        <span>Web Designer</span>
                    </div>
                </div>
                <div className="replace-svg--2">
                    <svg width="108" height="83" viewBox="0 0 108 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 82H49C55.6274 82 61 76.6274 61 70V41" stroke="#D1D7DD" />
                        <path d="M25 1H49C55.6274 1 61 6.37258 61 13V41" stroke="#D1D7DD" />
                        <path d="M108 40L102.973 37.1597L103.027 42.9329L108 40ZM0.00462943 41.5L103.505 40.5416L103.496 39.5417L-0.00462943 40.5L0.00462943 41.5Z" fill="#CAD4DD" />
                        <circle cx="61" cy="40" r="4.5" fill="white" stroke="#D1D7DD" />
                    </svg>

                </div>
                <div className="replace-right">
                AI Copilot for
                static ads 
                    {logo}

                </div>
            </div>
            <div className="replace-wrapper">
                <div className="replace-left">
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r8.webp'} alt="" />
                        <span>Acquisition Manager</span>
                    </div>
                    <div className="replace-item">
                        <img src={process.env.PUBLIC_URL + '/img/replace/r9.webp'} alt="" />
                        <span>Analyst</span>
                    </div>

                </div>
                <div className="replace-svg--3">
                    <svg width="125" height="44" viewBox="0 0 125 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 43H66C72.6274 43 78 37.6274 78 31V22" stroke="#D1D7DD" />
                        <path d="M42 1H66C72.6274 1 78 6.37258 78 13V22" stroke="#D1D7DD" />
                        <path d="M125 22L120 19.1132L120 24.8867L125 22ZM78 22.5L120.5 22.5L120.5 21.5L78 21.5L78 22.5Z" fill="#CAD4DD" />
                        <circle cx="78" cy="22" r="4.5" fill="white" stroke="#D1D7DD" />
                    </svg>


                </div>
                <div className="replace-right">
                AI Copilot for ad
                campaigns
                    {logo}

                </div>
            </div>
        </div>
    )
}
